import { useTranslation } from 'react-i18next';
import { hoverTooltipStyles } from './HoverTooltip';
import { riskReasonKey } from '../model/risk';

export interface IReasonRowsProps {
  reasons: string[];
}

/**
 * The translated risk-reason rows ("- behind schedule") shared by ReasonsTooltip
 * and DependencyTooltip, so a "primary +N" chip's hover always names every reason.
 */
export function ReasonRows({ reasons }: IReasonRowsProps) {
  const { t } = useTranslation();
  if (reasons.length === 0) return null;
  return (
    <section className={hoverTooltipStyles.section}>
      {reasons.map((reason) => (
        <span key={reason} className={hoverTooltipStyles.rowName}>
          - {t(riskReasonKey(reason))}
        </span>
      ))}
    </section>
  );
}
